import HotkeyModel from '@shared/models/deviceProfiles/HotkeyModel';
import { MacroDisplayCommandModel, MacroDisplayModel } from '@shared/models/deviceProfiles/MacroModel';

export const getHotkeyLocalId = (c: MacroDisplayCommandModel, hotkeys: HotkeyModel[]) => {
    if (c.hotkeyLocalId !== undefined) {
        return c.hotkeyLocalId;
    }
    const matchingHotkey = hotkeys.find((hotkey) => hotkey.command === c.command);
    if (matchingHotkey) {
        return matchingHotkey?.localId;
    }
};

export const getMacroForHotkey = (hotkey: HotkeyModel, macros: MacroDisplayModel[]) => {
    const matchingMacro = macros.find((macro) =>
        macro.commands.some((macroCommand) => macroCommand.command === hotkey.command)
    );
    if (!matchingMacro) return;
    const i = macros.indexOf(matchingMacro);
    return { m: matchingMacro, index: i };
};

export const getHotkeyFromCommand = (c: MacroDisplayCommandModel, hotkeys: HotkeyModel[]) => {
    const matchingHotkey = hotkeys.find((hotkey) => hotkey.command === c.command);
    if (!matchingHotkey) return;
    const i = hotkeys.indexOf(matchingHotkey);
    return { match: matchingHotkey, index: i };
};
